import { useContext } from 'react';

import { NavigationDragContext } from './navigation-drag-context';

export function useNavigation() {
  const context = useContext(NavigationDragContext);
  if (!context) {
    throw new Error('useNavigation must be used within NavigationDragProvider');
  }
  return context;
}
